"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getExportName = void 0;
var printDonationReminder_1 = require("../../donation-reminder/printDonationReminder");
function getExportName() {
    return printDonationReminder_1.printDonationReminder.name;
}
exports.getExportName = getExportName;
//# sourceMappingURL=getExportName.js.map